import Rocket from './Rocket';

export default Rocket;
